module.exports = __webpack_public_path__ + "assets/confetti-072e46.svg";